// Module
var code = `<ent
    tree-data="\$ctrl.availableLoanIndustryPurposeGroups"
    select-only-leaves="true"
    node-label="\$ctrl.label"
    ng-required="\$ctrl.ngRequired"
    ng-change="\$ctrl.onIndustryPurposeChange()"
    ng-model="\$ctrl.industryPurpose"
    ng-disabled="\$ctrl.ngDisabled"
    search="true">
</ent>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/loan/loan-industry-purpose.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;